import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Alert, Badge, Button, Table, Form } from "react-bootstrap";
import moment from "moment";
import Loader from "../../Loader/Loader";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";
import FilingPreview from "../../Filing/FilingPreview/FilingPreview";
import CatalogueAdd from "../CatalogueAdd/CatalogueAdd";
import CatalogueRemove from "../CatalogueRemove/CatalogueRemove";
import EntitiesExtraction from "../../Extraction/EntitiesExtraction/EntitiesExtraction";
import { orderBy } from "lodash";
import "./SelectionsList.scss";
import { Link } from "react-router-dom";
import { abbrivateCategories } from "../../../utils/StringUtils";
import EditIcon from "mdi-react/EditIcon";

class SelectionsList extends Component {
  constructor(props) {
    super(props);
    this.subscribedPromises = [];
    this.state = {
      selections: props?.selections || [],
      sortColumnMapping: {
        Company: { column: "filing.companyNameLong", direction: "desc" },
        CIK: { column: "filing.cik", direction: "desc" },
        "Form Type": { column: "filing.formType", direction: "desc" },
        "Filed At": { column: "filing.filedAt", direction: "desc" },
      },
      sortBy: "",
      sortSelection: {},
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps?.selections !== this.props?.selections) {
      this.setState({ selections: this.props?.selections || [] });
    }
  }

  showDocument(filing, doc) {
    this.setState({ preview: { filing: filing, doc: doc } });
  }

  hideDocument(filing) {
    this.setState({ preview: null });
  }

  selectDocument(ev) {
    const selected = ev.target.value;
    const checked = ev.target.checked;
    const { selections } = this.state;
    var { selectedDocs, onDocumentsSelected } = this.props;
    if (selected === "all") {
      selectedDocs = checked ? selections.map((item) => item.id) : [];
    } else {
      if (checked) selectedDocs.push(selected);
      else selectedDocs.splice(selectedDocs.indexOf(selected), 1);
    }
    this.setState({ selectedDocs: selectedDocs }, () =>
      onDocumentsSelected(this.state.selectedDocs)
    );
  }

  handleSortBy = (title) => {
    let { sortColumnMapping, sortSelection } = this.state;
    sortColumnMapping = {
      ...sortColumnMapping,
      [title]: {
        ...sortColumnMapping[title],
        direction:
          sortColumnMapping[title].direction === "asc" ? "desc" : "asc",
      },
    };
    sortSelection = {
      ...sortSelection,
      [title]: sortColumnMapping[title],
    };
    this.setState(
      {
        sortColumnMapping: sortColumnMapping,
        sortBy: title,
        sortSelection: sortSelection,
      },
      () => {
        this.sortData();
      }
    );
  };

  Heading = ({ title, classes = "" }) => {
    const { sortSelection, sortBy } = this.state;
    const direction = sortSelection[title]?.direction;
    const iconAsc = "south";
    const iconAscClass =
      sortBy === title && direction && (direction === "asc" ? "active" : "");
    const iconDesc = "north";
    const iconDescClass =
      sortBy === title && direction && (direction === "desc" ? "active" : "");
    return (
      <th
        className={classes}
        role={"button"}
        onClick={() => this.handleSortBy(title)}
      >
        {title}
        <span className={`material-icons sort ${iconAscClass}`}>{iconAsc}</span>
        <span className={`material-icons sort ${iconDescClass}`}>
          {iconDesc}
        </span>
      </th>
    );
  };

  sortData = () => {
    if (this.state.sortBy !== "") {
      const { sortColumnMapping, selections } = this.state;
      let column = sortColumnMapping[this.state.sortBy].column;
      if (column === "filing.cik") {
        column = (obj) => Number(obj.filing.cik);
      }
      const direction = sortColumnMapping[this.state.sortBy].direction;
      this.setState({
        selections: orderBy(selections, column, direction),
      });
    }
  };

  render() {
    const { preview, isLoading, error, selections } = this.state;
    const { Heading } = this;
    const { catalogue, selectedDocs, selectedFilter } = this.props;

    if (isLoading) return <Loader />;
    if (error) return <ErrorHandler error={error} />;

    return (
      <Fragment>
        {selections.length ? (
          <Table size="sm" className="table-hover">
            <thead>
              <tr>
                <th>SR</th>
                <th>
                  <Form.Check
                    aria-label="select"
                    checked={selectedDocs.length === selections.length}
                    value={"all"}
                    onChange={(ev) => this.selectDocument(ev)}
                  />
                </th>
                <Heading title="Company" />
                {selectedFilter === "createdAt" && <th>Filling Date</th>}
                <Heading title="CIK" />
                <th>Form Type</th>

                <th>Exhibit</th>
                <th>Catalogue</th>
                <th>Category</th>
                <th>Filing</th>
                <th className="catActionBtnWidth">Action</th>
              </tr>
            </thead>
            <tbody>
              {selections.map((catalogued, index) => {
                var filing = catalogued.filing;
                var doc = filing.documentFormatFiles.find(
                  (item) =>
                    item?.type === catalogued?.exhibit &&
                    item?.documentId === catalogued?.documentId
                );

                var inventories = catalogue
                  .filter(
                    (item) =>
                      item?.filingId === filing?.accessionNo &&
                      item?.exhibit === doc?.type
                  )
                  .map((item) => item.inventory)
                  .flat();
                inventories = inventories.filter(
                  (item, index, self) =>
                    self.findIndex((inventory) => inventory.id === item.id) ===
                    index
                );

                var categories = catalogue
                  .filter(
                    (item) =>
                      item?.filingId === filing?.accessionNo &&
                      item?.exhibit === doc?.type
                  )
                  .map((item) => item.category)
                  .flat();

                //   categories = categories.filter((item, index, self) => self.findIndex((category) => category.id === item.id) === index);

                const fillingDate = moment(
                  catalogued?.filing?.filingDate
                ).format("MM/DD/YYYY");
                return (
                  <tr key={index}>
                    <td>{++index}</td>
                    <td>
                      <Form.Check
                        className="z-n-1"
                        aria-label="select"
                        value={catalogued.id}
                        checked={selectedDocs.includes(catalogued.id)}
                        onChange={(ev) => this.selectDocument(ev)}
                      />
                    </td>
                    <td>{catalogued.filing.companyName}</td>
                    {selectedFilter === "createdAt" && <td>{fillingDate}</td>}

                    <td>{catalogued.filing.cik}</td>
                    <td>{catalogued.filing.formType}</td>

                    <td className="text-inline">
                      <Button
                        variant="link"
                        size="sm"
                        style={{ padding: "0px" }}
                        className="documentClass"
                        onClick={() => {
                          this.showDocument(filing, doc);
                        }}
                      >
                        {catalogued.exhibit}
                      </Button>
                    </td>
                    <td>
                      {inventories.map((item, index) => (
                        <Badge
                          variant="default"
                          size="sm"
                          className="ml-1 mr-1 badge-deal"
                          key={index}
                          title={item.name}
                        >
                          {item.name.match(/\b(\w)/g).join("")}
                        </Badge>
                      ))}
                    </td>
                    <td>
                      {categories.map((item, index) => (
                        <Badge
                          variant="default"
                          size="sm"
                          className="ml-1 mr-1 badge-deal"
                          key={index}
                          title={item.name}
                        >
                          {abbrivateCategories(item.name)}
                        </Badge>
                      ))}
                    </td>
                    <td>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        className="documentClass"
                        href={`https://www.sec.gov/Archives/edgar/data/${
                          catalogued.filing.cik
                        }/${catalogued.filing.accessionNo.replace(/-/gi, "")}/${
                          catalogued.filing.accessionNo
                        }-index.html`}
                      >
                        <span className="material-icons">launch</span>
                      </a>
                    </td>
                    <td>
                      {this.renderSelections(
                        catalogued.filing,
                        catalogued.exhibit,
                        catalogued.documentId
                      )}{" "}
                      <EntitiesExtraction catalogued={catalogued} />
                      {/* link to open new tab for filling form fields against document ( below ) */}
                      <Link
                        to={`/form-filing?selection_id=${catalogued.id}&filing_id=${filing.id}`}
                        onClick={() => {
                          this.renderFormPage(filing, doc, catalogued);
                        }}
                        target="_blank"
                        className="documentClass"
                      >
                        <EditIcon size={20} />
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        ) : (
          <Alert variant="info">
            <h4 className="mb-0">No items to show</h4>
          </Alert>
        )}
        {preview && (
          <FilingPreview
            filing={preview.filing}
            doc={preview.doc}
            btnShow={false}
            onDocumentClosed={() => this.hideDocument()}
            selections={selections}
            catalogue={this.props.catalogue}
            onCatalogueAdd={this.props.onCatalogueAdd}
            onCatalogueRemove={this.props.onCatalogueRemove}
          />
        )}
      </Fragment>
    );
  }

  /* *** render formSection on a separate page *** */
  renderFormPage(filing_$, doc_$, selection) {
    localStorage.setItem("filing", JSON.stringify(filing_$));
    localStorage.setItem("doc", JSON.stringify(doc_$));
    localStorage.setItem("selection", JSON.stringify(selection));
  }

  renderSelections(filing, type, docId) {
    const { selections } = this.state;
    const { onCatalogueAdd, onCatalogueRemove } = this.props;
    let doc = filing.documentFormatFiles.find(
      (item) => item.type === type && item.documentId === docId
    );
    var selected = selections.find(
      (item) =>
        item?.filingId === filing?.accessionNo &&
        item?.exhibit === type &&
        item?.documentId === doc?.documentId
    );
    return selected ? (
      <CatalogueRemove
        catalogued={selected}
        onFilingRemoved={onCatalogueRemove}
        screen={`selection`}
      />
    ) : (
      <CatalogueAdd
        doc={doc}
        filing={filing}
        onFilingAdded={onCatalogueAdd}
        screen={`selection`}
      />
    );
  }
}

SelectionsList.propTypes = {
  catalogue: PropTypes.array.isRequired,
  onCatalogueAdd: PropTypes.func.isRequired,
  onCatalogueRemove: PropTypes.func.isRequired,
  onDocumentsSelected: PropTypes.func.isRequired,
};

export default SelectionsList;
